<template>
  <div class="container">
    <Reply v-if="!isReply" :item='item' :isPhone="true" @reply="saveReply(item)" />
    <div v-else>
      <div class="header">
        <!-- <div class="icon"><i class="el-icon-arrow-left"></i></div> -->
        <div class="title h1">回复留言</div>
        <!-- <div class="icon"></div> -->
      </div>
      <div class="content">
        <el-card class="box-card">
          <p>回复成功~</p>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import Reply from '@/components/messageReply'
export default {
  name: 'messageReply',
  data () {
    return {
      item: {},
      isReply: false,
      itemId: ''
    }
  },
  components: {
    Reply
  },
  mounted () {
    console.log(this.$route.params.id)
    this.itemId = this.$route.params.id
    this.getItemInfo()
  },
  methods: {
    getItemInfo () {
      this.$http.getItemInfo({id: this.itemId}).then((result) => {
        console.log(result)
        if (result.success) {
          this.item = result.data
          if (result.data.reply) {
            this.isReply = true
          }
        }
      }).catch((err) => {
        console.error(err)
      })
    },
    saveReply (item) { // 提交留言回复
      let para = {
        questionId: item.id,
        rContent: item.rcontent,
        username: item.username,
        telephone: item.telephone,
        isPublish: item.isPublish
      }
      this.$http.saveReply(para).then(res => {
        console.log(res)
        if (res.success) {
          // this.$message({
          //   showClose: true,
          //   message: res.msg,
          //   type: 'success'
          // })
          this.getItemInfo()
        }
      }).catch(err => {
        console.error(err)
      })
    }
  }
}
</script>
<style lang='scss'>

</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$color: #6e348b;

.el-message {
  padding: 10px 10px 10px 15px;
}

.header {
  display: flex;
  justify-content: center;
  color: $color;
  padding: 10px 0;
  font-size: 1em;
  font-weight: 600;

  .icon {
    width: 30px;
  }
}

.el-card {
  margin: 10px 0;

  .item-title {
    display: flex;
    color: #606266;
    justify-content: space-between;
    font-size: 14px;
    margin-bottom: 10px;
  }

  .item-content {
    &>div {
      font-size: 14px;
      margin-bottom: 10px;
      color: black;
    }
  }
}

.el-button {
  width: 100%;
  margin-top: 30px;
}

.box-card {
  p {
    font-size: .65em;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/messageReply.vue